export default {
    i18n: {
        "Group": "Nhóm",
        "Device Name": "Tên thiết bị",
        "day": "ngày",
        "Device Information": "Thông tin thiết bị",
        "handset": "Tay cầm",
        "bluetooth": "Bluetooth",
        "Volume": "Âm lượng",
        "Http": "HTTP",
        "Access Denied.": "Truy cập bị từ chối.",
        "tamperAlarm": "Cảnh báo phá hoại",
        "Card": "Thẻ",
        "Fingerprint": "Vân tay",
        "Date Time": "Ngày Giờ",
        "name": "tên",
        "minutes": "phút",
        "timezone": "múi giờ",
        "Are you sure you want to delete this device?": "Bạn có chắc là bạn muốn xóa thiết bị này không?",
        "Attendance Point Name": "Tên điểm chấm công",
        "Mac": "Mac",
        "confirmToDeleteIt?": "Xác nhận để xóa?",
        "captureLogs": "Nhật ký chụp hình",
        "Doors": "(Các) cửa",
        "All Doors": "Tất cả cửa",
        "Lock List": "Danh sách khóa",
        "Link Device Relay": "Liên kết Rơ-le thiết bị",
        "Added Successfully!": "Đã được thêm thành công",
        "When the lock is linked with a relay, the lock will be unlocked when relay is triggered.": "Khi khóa đã được kết nối với rơ-le, khóa sẽ được mở khi rơ-le được kích hoạt",
        "Adding...": "Đang thêm...",
        "Please try again 24 hours later.": "Vui lòng thử lại sau 24 giờ.",
        "Action": "Hành động",
        "unlock": "mở khóa",
        "Address": "Địa chỉ",
        "Owner": "Chủ sở hữu",
        "Failed": "Thất bại",
        "Timeout": "Hết giờ",
        "Response": "Phản ứng",
        "caller": "Người gọi",
        "receiver": "Người nhận",
        "doorLogs": "Nhật ký cửa",
        "callHistory": "Lịch sử cuộc gọi",
        "UID": "UID",
        "Call Type": "Loại cuộc gọi",
        "Code": "Mật mã",
        "User": "Người dùng",
        "Device List": "Danh sách thiết bị",
        "Model": "Người mẫu",
        "Time": "Thời gian",
        "Company": "Công ty",
        "Property Managers": "Những Người Tổng quản lý",
        "Current Version": "Phiên bản hiện tại",
        "indoorMonitor": "Màn hình chuông",
        "guardPhone": "Điện thoại an ninh",
        "close": "Đóng",
        "Success": "Thành công",
        "URL": "URL",
        "Please select a device.": "Hãy chọn một thiết bị.",
        "Password is too weak.": "Mật khẩu quá yếu.",
        "Company is required.": "Tên công ty là bắt buộc.",
        "Your account is not activated, please contact your service provider.": "Tài khoản của bạn chưa được kích hoạt, vui lòng liên hệ với nhà cung cấp dịch vụ.",
        "Language": "Ngôn ngữ",
        "Face": "Nhập dữ liệu khuôn mặt",
        "Please set at least one access type.": "Vui lòng đặt ít nhất một loại truy cập.",
        "Please contact your service provider to activate this advanced feature.": "Vui lòng liên hệ với nhà cung cấp dịch vụ của bạn để kích hoạt tính năng nâng cao này.",
        "Community name": "Tên cộng đồng",
        "Please enable PM App first.": "Vui lòng bật Ứng dụng PM trước.",
        "Username": "Tên tài khoản",
        "Change Log": "Nhật ký thay đổi",
        "Assign": "Chỉ định",
        "Floor": "Tầng",
        "Link Device": "Liên kết thiết bị",
        "Accessible Floors": "Sàn có thể truy cập",
        "Upgrade": "Nâng cấp",
        "Function": "Chức năng",
        "callDuration": "Thời lượng cuộc gọi",
        "No": "Không",
        "Verification Code": "Mã xác nhận",
        "Expiration Time": "Thời gian hết hạn",
        "PIN": "PIN",
        "MAC": "Mac",
        "Building": "Tòa nhà",
        "APT": "APT",
        "ID": "ID",
        "Name": "Tên",
        "activities": "Hoạt động",
        "Obtain": "Nhập",
        "call": "Gọi",
        "Group Call": "Nhóm gọi",
        "Delete": "Xóa bỏ",
        "Yes": "Có",
        "Door Release PIN": "Mã PIN mở cửa",
        "Email": "Thư điện tử",
        "Mobile Number doesn\'t exist.": "Số điện thoại không tồn tại",
        "Tips": "Mẹo",
        "Password": "Mật khẩu",
        "The end time cannot be earlier than the start time.": "Thời gian kết thúc không được sớm hơn thời gian bắt đầu.",
        "Back": "Mặt sau",
        "File format error.": "Lỗi định dạng tệp.",
        "motionDetection": "Phát hiện chuyển động",
        "You are trying too often, please try again in 5 minutes": "Bạn đang cố gắng quá mức, hãy thử lại sau 5 phút",
        "User name too long.": "Tên người dùng quá dài.",
        "This MAC address is redirected on RPS.": "Địa chỉ MAC này được chuyển hướng trên RPS.",
        "No Answer": "Không trả lời",
        "failedToUnlock": "Mở khóa thất bại",
        "visitor": "khách",
        "yesterday": "Hôm qua",
        "Too large data! Please first export the data before %s first,thanks.": "Dữ liệu quá lớn! Trước tiên, hãy xuất dữ liệu trước %s, cảm ơn.",
        "Please check if there is any unpaid orders, if not, please contact your service provider.": "Vui lòng kiểm tra xem có đơn hàng nào chưa thanh toán không, nếu không, vui lòng liên hệ với nhà cung cấp dịch vụ của bạn",
        "lock": "Khóa",
        "open": "Mở",
        "The PersonalAccount is not active.": "Tài khoản cá nhân không hoạt động.",
        "You cannot link an account that already link other accounts.": "Bạn không thể liên kết một tài khoản đã liên kết các tài khoản khác.",
        "You cannot link multiple property manager accounts under the same installer account.": "Bạn không thể liên kết nhiều tài khoản Trình quản lý thuộc tính trong cùng một tài khoản trình cài đặt.",
        "You cannot link to the currently logged in account.": "Bạn không thể liên kết đến tài khoản hiện đã đăng nhập.",
        "nfc": "NFC",
        "Delete Device": "Xóa thiết bị",
        "date": "Ngày",
        "Device deleted successfully": "Thiết bị đã xóa thành công",
        "Failed to delete device": "Không xóa thiết bị",
        "Are you sure you want to cancel?": "Bạn có chắc chắn muốn hủy không?",
        "Unlimited": "Vô hạn",
        "Battery Level": "Mức pin",
        "Password Incorrect.": "Mật khẩu không đúng.",
        "deliverySystemVerification": "Xác minh hệ thống giao hàng",
        "Upgrading...": "Đang nâng cấp...",
        "amenityReservation": "Đặt chỗ tiện nghi",
        "idAccess": "ID truy cập",
        "RF Card": "Thẻ RF",
        "exitButton": "Nút mở cửa",
        "Please select at least one item.": "Vui lòng chọn ít nhất một mục.",
        "The ID can contain only digits and letters, up to 32 characters.": "ID chỉ có thể chứa chữ số và chữ cái, tối đa 32 ký tự.",
        "The PIN is not available.": "Mã PIN không khả dụng.",
        "Change WiFi": "Đổi WiFi",
        "Phone number": "Số điện thoại",
        "Invalid {0}.": "{0} không hợp lệ.",
        "{0} already exists.": "{0} đã tồn tại.",
        "Operation failed!": "Thao tác thất bại!",
        "Failed to get data.": "Lấy dữ liệu thất bại.",
        "You do not have the necessary permissions to perform this operation.": "Bạn không có quyền cần thiết để thực hiện thao tác này.",
        "You can only import one template at a time in the current site.": "Bạn chỉ có thể nhập một mẫu tại một thời điểm trên trang web hiện tại.",
        "Delivery name": "Tên ủy quyền giao hàng",
        "MAC address not in the MAC library.": "Địa chỉ MAC không có trong thư viện MAC.",
        "Please delete devices under this building.": "Vui lòng xóa các thiết bị dưới tòa nhà này.",
        "The start time cannot be later than the end time.": "Thời gian bắt đầu không được muộn hơn thời gian kết thúc.",
        "emergency action type": "Loại hành động khẩn cấp",
        "Only 1000 data items can be imported at a time.": "Chỉ có thể nhập tối đa 1000 mục dữ liệu cùng một lúc.",
        "The password is too short.": "Mật khẩu quá ngắn.",
        "The data has been updated. Please refresh the page and try again.": "Dữ liệu đã được cập nhật. Vui lòng làm mới trang và thử lại.",
        "AutoP length must be less 2048 bytes.": "Độ dài lệnh AutoP phải nhỏ hơn 2048 byte.",
        "File Check Failed": "Kiểm tra tệp thất bại",
        "administratorAccountLoginHasExpired.PleaseContactYourServiceProvider.": "Tài khoản quản trị viên đã hết hạn, vui lòng liên hệ nhà cung cấp dịch vụ của bạn.",
        "iqPinVerificationFailed": "Xác thực mã PIN IQ thất bại.",
        "accountBlacklisted": "Tài khoản bị đưa vào danh sách đen.",
        "outsideAuthorizedTime": "Ngoài thời gian cho phép.",
        "network group": "nhóm mạng",
        "Company name": "Tên công ty",
        "Group name": "Tên nhóm",
        "relay": "rơ-le",
        "motionTime": "thời gian phát hiện chuyển động",
        "motionType": "loại phát hiện chuyển động",
        "postalCode": "mã bưu điện",
        "floor format": "định dạng tầng",
        "mobilePhone": "số điện thoại di động",
        "time format": "định dạng thời gian",
        "security relay": "rơ le an toàn",
        "Param": "Tham số",
        "Offline Code": "Mã ngoại tuyến",
        "Add akubela Smart Locks": "Thêm khóa thông minh akubela",
        "Module Version": "Phiên bản mô-đun",
        "Lock Body Version": "Phiên bản thân khóa",
        "Available Version": "Phiên bản có sẵn",
        "Please wake up the lock screen and then upgrade.": "Vui lòng đánh thức màn hình khóa rồi nâng cấp.",
        "This process will take some time, please be patient.": "Quá trình này sẽ mất một chút thời gian, vui lòng kiên nhẫn.",
        "Please confirm that the WiFi network is functioning properly.": "Vui lòng xác nhận mạng WiFi đang hoạt động bình thường.",
        "Please wake up the lock screen.": "Vui lòng đánh thức màn hình khóa.",
        "This lock has already been added to another apartment.": "Khóa này đã được thêm vào một căn hộ khác.",
        "This lock has already been added to the apartment.": "Khóa này đã được thêm vào căn hộ.",
        "Pin Code": "Mã PIN",
        "Too many failed attempts, please try again in a few minutes.": "Quá nhiều lần thử không thành công, vui lòng thử lại sau vài phút.",
        "Login Account": "Đăng nhập tài khoản",
        "Same account cannot login in different ins.": "Cùng một tài khoản không thể đăng nhập vào các nhà lắp đặt khác nhau.",
        "Lock Name": "Tên khóa",
        "Smart Locks": "Khóa thông minh",
        "Add Smart Lock": "Thêm Khóa thông minh",
        "The selected duration cannot be more than one year.": "Thời gian được chọn không được vượt quá một năm.",
        "The end time of the break time cannot be later than the end work time.": "Thời gian kết thúc của giờ nghỉ không được muộn hơn thời gian kết thúc làm việc.",
        "The start time of the break time cannot be earlier than the start work time.": "Thời gian bắt đầu nghỉ giải lao không được sớm hơn thời gian bắt đầu làm việc.",
        "The end time of the valid check time cannot be earlier than the end work time.": "Thời gian kết thúc của thời gian kiểm tra hợp lệ không được sớm hơn thời gian kết thúc làm việc.",
        "The start time of the valid check time cannot be later than the start work time.": "Thời gian bắt đầu kiểm tra hợp lệ không được muộn hơn thời gian bắt đầu làm việc.",
        "Deleting failed. The timetable is used by a shift.": "Xóa không thành công. Thời gian biểu đang được một ca làm việc sử dụng.",
        "Deleting failed. The shift is in use.": "Xóa không thành công. Ca làm việc đang được sử dụng.",
        "Deleting failed. The leave type is in use.": "Xóa không thành công. Loại nghỉ phép đang được sử dụng.",
        "Valid time conflicts with an existing schedule.": "Thời gian hợp lệ bị trùng với lịch trình hiện có.",
        "The timing for multiple schedules must not coincide.": "Thời gian của nhiều lịch trình không được trùng nhau.",
        "Attendance Log": "Nhật ký chấm công",
        "Added Failed!": "Thêm thất bại!",
        "Setting WiFi": "Đang cài đặt WiFi",
        "License Plate": "Biển số xe",
        "key": "Mật khẩu",
        "IQ Offline.": "IQ Ngoại tuyến.",
        "{0}Unlock": "{0} mở khóa",
        "automatically": "Tự động",
        "manually": "Thủ công",
        "Video Storage": "Lưu trữ video",
        "Device(s) for Video Storage": "Thiết bị lưu trữ video",
        "The amount of exported data is too large. Please export it in batches.": "Lượng dữ liệu xuất ra quá lớn. Vui lòng xuất dữ liệu theo từng đợt.",
        "Auto-record video when door unlocks": "Tự động ghi hình khi mở cửa",
        "Auto-record video during calls": "Tự động ghi hình khi đang gọi",
        "Manual video recording in monitoring": "Ghi hình thủ công trong chế độ giám sát",
        "Saved for 30days/60days/90days": "Lưu trong 30 ngày/60 ngày/90 ngày",
        "To subscribe, please contact your provider for activation.": "Để đăng ký, vui lòng liên hệ nhà cung cấp của bạn để kích hoạt.",
        "Saved for {0}days": "Lưu trong {0} ngày",
        "Subscribed Plan": "Gói đăng ký",
        "Supported Devices: {0}": "Thiết bị được hỗ trợ: {0}",
        "{0}Lock": "{0} khóa cửa",
        "Video Saving": "Lưu video",
        "Download Completed!": "Đã tải xuống xong!",
        "Fail to download.": "Tải xuống thất bại.",
        "Deleting failed! The property manager has been bound to a RentManager Customer, you should delete it firstly.": "Xóa không thành công! Quản lý tài sản đã được liên kết với tài khoản khách hàng RentManager, bạn nên xóa liên kết này trước.",
        "No log to be exported.": "Không có bản ghi nào để xuất.",
        "capture&Video": "Chụp hình & Video",
        "packageDetection": "Phát hiện gói hàng",
        "Time format is invalid.": "Định dạng thời gian không hợp lệ.",
        "No permission to export logs of this type.": "Không có quyền xuất nhật ký loại này.",
        "Project type is invalid.": "Loại dự án không hợp lệ.",
        "Salto Account Blocked.": "Tài khoản Salto đã bị khóa.",
        "Remote open not in access group.": "Không thể mở cửa từ xa vì không thuộc nhóm quyền truy cập.",
        "SIP Account required.": "Yêu cầu tài khoản SIP.",
        "The PIN must be {0} digits.": "Mã PIN phải có {0} chữ số.",
        "gatewayConnectionUnavailable": "Kết nối gateway không khả dụng.",
        "Invalid Username or Password": "Tên đăng nhập hoặc mật khẩu không hợp lệ",
        "Account already linked to another user.": "Tài khoản đã được liên kết với người dùng khác.",
        "The account has been added by another user.": "Tài khoản này đã được người dùng khác thêm vào.",
        "Failed to add. This user already has 5 license plates.": "Thêm không thành công. Người dùng này đã có 5 biển số xe.",
        "Please at least select a door.": "Vui lòng chọn ít nhất một cửa.",
        "UHF Card": "Thẻ UHF",
        "personnel": "nhân sự",
        "Parking Lot Name": "Tên bãi đỗ xe",
        "Controlled Relay": "Rơ-le điều khiển",
        "No Permission": "Không có quyền",
        "Please ensure that all doors in the project are activated at the same time.": "Vui lòng đảm bảo rằng tất cả các cửa trong dự án đều được kích hoạt cùng một lúc.",
        "gatewayBusy": "Gateway đang bận",
        "Please set the perimeter door group first.": "Vui lòng thiết lập nhóm cửa chu vi trước.",
        "Please ensure that all doors in the project are renewed at the same time.": "Vui lòng đảm bảo rằng tất cả các cửa trong dự án đều được gia hạn cùng một lúc.",
        "When lockdown is on, the controlled relay cannot be modified.": "Khi chế độ khóa được bật, rơ le điều khiển không thể được thay đổi.",
        "DetectionLogs": "Nhật ký phát hiện",
        "packageIn": "Đặt gói vào",
        "packageOut": "Lấy gói ra",
        "View Progress": "Xem tiến trình",
        "Check if the WiFi is operating on the 2.4GHz band.": "Kiểm tra xem WiFi có đang hoạt động trên băng tần 2.4GHz không.",
        "Verify that the WiFi password is correct.": "Xác minh rằng mật khẩu WiFi là chính xác.",
        "Ensure that you are connected to the correct device hotspot during the hotspot configuration.": "Đảm bảo bạn đã kết nối với điểm phát sóng của thiết bị đúng trong quá trình cấu hình điểm phát sóng.",
        "Offline Code Unlock": "Mở cửa bằng mã ngoại tuyến",
        "Salto Token Expired.": "Mã thông báo Salto đã hết hạn.",
        "Lock Offline": "Khóa ngoại tuyến",
        "identity information! Please login again": "Thông tin định danh! Vui lòng đăng nhập lại",
        "Email is required.": "Email là bắt buộc.",
        "Mobile number is required.": "Số điện thoại di động là bắt buộc.",
        "You can\'t make payments for offices in different time zones.": "Bạn không thể thanh toán cho các văn phòng ở các múi giờ khác nhau.",
        "The current scheduling staff exceeds 200 people.": "Số nhân viên được xếp lịch hiện tại đã vượt quá 200 người.",
        "param": "tham số",
        "Invalid UserName or Password": "Tên người dùng hoặc mật khẩu không hợp lệ",
        "Your Salto KS account does not have permission to modify the lock\'s name.": "Tài khoản Salto KS của bạn không có quyền thay đổi tên của khóa.",
        "Owner is required.": "Yêu cầu có chủ sở hữu.",
        "Office is required.": "Cần có văn phòng.",
        "PIN or RF Card is required.": "Yêu cầu mã PIN hoặc thẻ RF.",
        "RF card": "Thẻ RF",
        "Personnel is required.": "Cần nhân sự.",
        "email address": "địa chỉ email",
        "mobile number": "Số điện thoại di động",
        "The length must be less than 32 characters.": "Độ dài phải nhỏ hơn 32 ký tự.",
        "The length must be less than 256 characters.": "Độ dài phải nhỏ hơn 256 ký tự.",
        "Access Group is required.": "Yêu cầu nhóm quyền truy cập.",
        "Device is required.": "Yêu cầu thiết bị.",
        "Admin is required.": "Yêu cầu quản trị viên.",
        "Mobile number": "Số điện thoại di động",
        "schedules": "lịch trình",
        "Timetable name": "Tên thời gian biểu",
        "Shift name": "Tên ca làm việc",
        "Leave type": "Loại nghỉ phép",
        "recheck in time": "thời gian điểm danh vào lại",
        "recheck out time": "thời gian điểm danh ra lại",
        "The building name": "Tên tòa nhà",
        "Building is required.": "Yêu cầu tòa nhà.",
        "selection, The same reader cannot be set for both entry and exit": "lựa chọn, Không thể đặt cùng một đầu đọc cho cả lối vào và lối ra",
        "Door number": "Số cửa",
        "door input cannot be selection duplicated.": "Không thể chọn trùng lặp đầu vào cửa.",
        "Group is required.": "Yêu cầu nhóm.",
        "Title can contain up to 32 characters.": "Tiêu đề có thể chứa tối đa 32 ký tự.",
        "Content can contain up to 1024 characters.": "Nội dung có thể chứa tối đa 1024 ký tự.",
        "Content can contain up to 64 characters.": "Nội dung có thể chứa tối đa 64 ký tự.",
        "Report is required.": "Báo cáo là bắt buộc.",
        "ID is required.": "Cần ID.",
        "The office does not exist.": "Văn phòng không tồn tại.",
        "Office name": "Tên văn phòng",
        "The Temp Key does not exist.": "Khóa tạm thời không tồn tại.",
        "autolock time": "thời gian tự động khóa",
        "The User does not exist.": "Người dùng không tồn tại.",
        "The Installer does not exist.": "Nhà lắp đặt không tồn tại.",
        "The Project does not exist.": "Dự án không tồn tại.",
        "The Distributor does not exist.": "Nhà phân phối không tồn tại.",
        "The Community Device does not exist.": "Thiết bị cộng đồng không tồn tại.",
        "The Property Manager does not exist.": "Người quản lý tài sản không tồn tại.",
        "The Sub Distributor does not exist.": "Nhà phân phối phụ không tồn tại.",
        "The Single Slave does not exist.": "Tài khoản phụ của hộ đơn không tồn tại.",
        "The Property Manager EndUser does not exist.": "Người dùng cuối của Quản lý Tài sản không tồn tại.",
        "The Family Member does not exist.": "Thành viên gia đình không tồn tại.",
        "Set Failed!": "Thiết lập thất bại!",
        "You have reached the limit of 10 access code requests within a 30-minute period. Please try again later.": "Bạn đã đạt giới hạn 10 lần yêu cầu mã truy cập trong vòng 30 phút. Vui lòng thử lại sau.",
        "This Email doesn\'t exist.": "Email này không tồn tại.",
        "detection type": "loại phát hiện",
        "Device UUID": "UUID thiết bị",
        "smart lock device": "thiết bị khóa thông minh",
        "You are trying too often, please try again in 5 minutes.": "Bạn thao tác quá thường xuyên, vui lòng thử lại sau 5 phút.",
        "You can only import one file at a time. Please wait for the current import to finish.": "Bạn chỉ có thể nhập một tệp tại một thời điểm. Vui lòng đợi quá trình nhập hiện tại hoàn tất.",
        "NVR Name": "Tên NVR",
        "NVR Address": "Địa chỉ NVR",
        "Stay Alarm": "Cảnh báo lưu trú",
        "Happended On": "Xảy ra lúc",
        "Edit Milesight NVR": "Chỉnh sửa Milesight NVR",
        "Add Milesight NVR": "Thêm Milesight NVR",
        "Auto-record video on motion detection, package detection": "Tự động ghi hình khi phát hiện chuyển động, gói hàng",
        "A 7-day free trial is included with your subscription.": "Đăng ký của bạn bao gồm 7 ngày dùng thử miễn phí.",
        "For service renewal, please reach out to your provider.": "Để gia hạn dịch vụ, vui lòng liên hệ nhà cung cấp của bạn.",
        "Allow the Property Manager to view recorded videos": "Cho phép quản lý tài sản xem video đã ghi",
        "Please ensure the WiFi network is working properly.": "Vui lòng đảm bảo mạng WiFi hoạt động bình thường.",
        "Edit akubela Smart Locks": "Chỉnh sửa khóa thông minh akubela",
        "Upgraded Successfully!": "Nâng cấp thành công!",
        "Upgraded Failed!": "Nâng cấp thất bại!",
        "Editing...": "Đang chỉnh sửa...",
        "Edited successfully!": "Chỉnh sửa thành công!",
        "Edited Failed!": "Chỉnh sửa thất bại!",
        "Downloading video...": "Đang tải video...",
        "All Locks": "Tất cả khóa",
        "Select Locks": "Chọn khóa",
        "The {0} digits PIN can be used once the akubela smart lock is connected to the network. Please note that it may take a short time for the PIN to take effect after synchronization.": "Sau khi khóa thông minh akubela kết nối mạng, có thể sử dụng mã PIN {0} chữ số. Lưu ý rằng sau khi đồng bộ, mã PIN có thể mất một chút thời gian để có hiệu lực.",
        "Please at least select a door or a lock.": "Vui lòng chọn ít nhất một cửa hoặc một khóa.",
        "This lock has already been added to your apartment.": "Khóa này đã được thêm vào phòng của bạn.",
        "This lock has already been added to another apartment, please contact your service provider for assistance.": "Khóa này đã được thêm vào một phòng khác, vui lòng liên hệ nhà cung cấp dịch vụ của bạn để được hỗ trợ.",
        "LockBody Version": "Phiên bản thân khóa",
        "Two-factor Authentication": "Xác thực hai yếu tố",
        "Monitoring Scope": "Phạm vi giám sát",
        "Stay Duration": "Thời gian lưu lại",
        "Volume Settings": "Cài đặt âm lượng",
        "get card list for lock error": "Lỗi khi lấy danh sách thẻ bị khóa",
        "get card list parse fail": "Không thể phân tích cú pháp danh sách thẻ",
        "get pin list for lock error": "Lỗi khi lấy danh sách mã PIN của khóa",
        "get pin list parse fail": "Không thể phân tích cú pháp danh sách mã PIN",
        "fingerprint code must be less than 2048 characters or empty.": "Mã vân tay phải ít hơn 2048 ký tự hoặc để trống.",
        "Personnel not in office.": "Nhân sự không có mặt tại văn phòng.",
        "customize form fail.": "Tùy chỉnh biểu mẫu thất bại.",
        "smart lock type error.": "Lỗi loại khóa thông minh.",
        "invalid client id or secret": "ID client hoặc secret không hợp lệ",
        "invalid account or password": "Tài khoản hoặc mật khẩu không hợp lệ",
        "invalid access token": "Access token không hợp lệ",
        "invalid refresh token": "Refresh token không hợp lệ",
        "no permission to access this project": "Không có quyền truy cập dự án này",
        "Stay Alarm Time": "Thời gian báo động giữ",
        "This function only support sl20 lock.": "Chức năng này chỉ hỗ trợ khóa sl20.",
        "Json marshal error.": "Lỗi marshal Json.",
        "Json unmarshal error.": "Lỗi unmarshal Json.",
        "Illegal request, not added within valid time.": "Yêu cầu không hợp lệ, không được thêm trong thời gian hợp lệ.",
        "invalid nvr type": "Loại NVR không hợp lệ",
        "project is empty": "Dự án trống",
        "project type is invalid": "Loại dự án không hợp lệ",
        "owner is invalid": "Chủ sở hữu không hợp lệ",
        "url is invalid": "URL không hợp lệ",
        "password is invalid": "Mật khẩu không hợp lệ",
        "building is invalid": "Tòa nhà không hợp lệ",
        "fail to get data": "Không thể lấy dữ liệu",
        "invalid allow pm view type": "Loại phép xem PM không hợp lệ",
        "Data not exist.": "Dữ liệu không tồn tại.",
        "cannot find community PrivateKey.": "Không tìm thấy mã PrivateKey của cộng đồng.",
        "cannot find single PrivateKey.": "Không tìm thấy PrivateKey riêng lẻ.",
        "The third party not exist.": "Bên thứ ba không tồn tại.",
        "{0} and indoor monitors/guard phones": "{0} và màn hình trong nhà/điện thoại bảo vệ",
        "{0} and indoor monitors/guard phones, with phone as backup": "Gọi trước {0} và màn hình trong nhà/điện thoại bảo vệ, không ai nghe thì gọi số điện thoại",
        "Indoor monitors/guard phones with {0} as backup": "Gọi trước màn hình trong nhà/điện thoại bảo vệ, không ai nghe thì gọi {0}",
        "Indoor monitors/guard phones with {0} as backup, finally the phone": "Gọi trước màn hình trong nhà/điện thoại bảo vệ, không ai nghe thì gọi {0}, cuối cùng gọi số điện thoại",
        "{0} Intercom Feature": "Tính năng liên lạc nội bộ {0}",
        "Capture on {0}": "Chụp màn hình trên {0}",
        "{0} Intercom Feature is not activated or has expired.": "Tính năng liên lạc nội bộ {0} chưa được kích hoạt hoặc đã hết hạn.",
        "fingerprint code must be equal 1620 characters or empty.": "Mã vân tay phải bằng 1620 ký tự hoặc để trống.",
        "To ensure a successful upgrade, please make sure the lock\'s battery level is above 40% before proceeding.": "Để đảm bảo nâng cấp thành công, vui lòng đảm bảo mức pin của khóa trên 40% trước khi tiếp tục.",
        "Automatic Locking Time": "Thời gian khóa tự động",
        "WiFi Keep-Alive": "Duy trì WiFi",
        "WiFi Setting": "Cài đặt WiFi",
        "Connecting the network...": "Đang kết nối mạng...",
        "Set successfully!": "Cài đặt thành công!",
        "The offline code can be used even if the lock is not connected to WiFi.": "Mã ngoại tuyến vẫn có thể sử dụng dù khóa không kết nối WiFi.",
        "Enabling this feature will increase the lock\'s power consumption.": "Bật tính năng này sẽ tăng mức tiêu thụ pin của khóa.",
        "Each offline code can only be used once.": "Mỗi mã ngoại tuyến chỉ sử dụng được một lần.",
        "Receiver Info": "Thông tin người nhận",
        "log id": "ID đăng nhập",
        "Create HW SN Config Empty SN.": "Tạo cấu hình HW SN với SN trống.",
        "The SN": "Số sê-ri",
        "SN can contain up to 32 characters.": "SN có thể chứa tối đa 32 ký tự.",
        "Check HW SN Not Found.": "Không tìm thấy SN HW.",
        "the end user not found": "Không tìm thấy người dùng cuối",
        "Family Call": "Gọi gia đình",
        "During the upgrade, all lock-related functions will be temporarily unavailable.": "Trong quá trình nâng cấp, tất cả các chức năng liên quan đến khóa sẽ tạm thời không khả dụng.",
        "8-digit PIN code starting with \"9\" is invalid!": "Mã PIN 8 chữ số bắt đầu bằng \"9\" không hợp lệ!",
        "Lock name length must be between 1 and 50": "Độ dài tên khóa phải từ 1 đến 50 ký tự.",
        "The number of personnel with landline service cannot exceed the number of those with {0} Intercom.": "Số lượng nhân sự sử dụng dịch vụ gọi số điện thoại di động không được vượt quá số lượng sử dụng dịch vụ liên lạc {0}.",
        "The number of admins with landline service cannot exceed the number of those with {0} Intercom.": "Số lượng quản trị viên có dịch vụ gọi số điện thoại di động không được vượt quá số lượng quản trị viên có dịch vụ {0} Intercom.",
        "charge type": "loại phí",
        "The number of personnel with landline service cannot exceed the number of those with SmartPlus Intercom.": "Số lượng nhân viên sử dụng dịch vụ điện thoại cố định không được vượt quá số lượng nhân viên sử dụng dịch vụ liên lạc SmartPlus.",
        "The number of admins with landline service cannot exceed the number of those with SmartPlus Intercom.": "Số lượng quản trị viên có dịch vụ gọi số điện thoại di động không được vượt quá số lượng quản trị viên có dịch vụ liên lạc SmartPlus.",
        "A reader cannot be configured to use both Wiegand and RS485 simultaneously.": "Đầu đọc thẻ không thể được cấu hình để sử dụng đồng thời cả Wiegand và RS485.",
        "parameter error": "lỗi tham số",
        "community name already exist": "tên cộng đồng đã tồn tại",
        "personnel app without intercom feature number": "ứng dụng nhân sự không có số tính năng liên lạc nội bộ",
        "check feature billing charge plan new error": "lỗi kiểm tra kế hoạch tính phí tính năng mới",
        "subscription not found": "không tìm thấy đăng ký",
        "System setting record not found.": "Không tìm thấy bản ghi cài đặt hệ thống.",
        "Smart home not enabled.": "Nhà thông minh chưa được kích hoạt.",
        "the apt call type value is invalid.": "giá trị kiểu gọi apt không hợp lệ.",
        "the ip call or sip call value is invalid.": "giá trị gọi IP hoặc SIP không hợp lệ.",
        "pinCode must be 2-8 digit number, but cannot be an 8-digit number starting with 9 or empty.": "pinCode phải là số từ 2-8 chữ số, nhưng không được là số 8 chữ số bắt đầu bằng 9 hoặc để trống.",
        "rfCard must be A-F0-9 and less than 16 bits or empty.": "rfCard phải là các ký tự từ A-F và 0-9, nhỏ hơn 16 ký tự hoặc để trống.",
        "owner cannot be empty.": "chủ sở hữu không được để trống.",
        "creator cannot be empty.": "người tạo không được để trống.",
        "the creator type value is invalid": "giá trị loại người tạo không hợp lệ",
        "the IsCreateByPm value is invalid": "giá trị IsCreateByPm không hợp lệ",
        "the pinCode already exist": "pinCode đã tồn tại",
        "the rfCard already exist": "rfCard đã tồn tại",
        "license plate is invalid.": "biển số xe không hợp lệ.",
        "owner info is invalid.": "thông tin chủ sở hữu không hợp lệ.",
        "uhf is invalid.": "uhf không hợp lệ.",
        "time control is invalid.": "điều khiển thời gian không hợp lệ.",
        "You have reached the limit of 5 Vehicle License Plate and are not allowed to add": "Bạn đã đạt giới hạn 5 biển số xe và không được phép thêm.",
        "the plate already exist": "biển số đã tồn tại",
        "the uhf already exist": "uhf đã tồn tại",
        "empty community": "cộng đồng trống",
        "no find license Plate": "không tìm thấy biển số xe",
        "IDAccess mode must be 0, 1, or 2.": "Chế độ IDAccess phải là 0, 1 hoặc 2.",
        "Run field is required when mode is 1 or 2.": "Trường Run là bắt buộc khi chế độ là 1 hoặc 2.",
        "Serial field is required when mode is 2.": "Trường Serial là bắt buộc khi chế độ là 2.",
        "the pin cannot be empty": "mã pin không được để trống",
        "the rfCard cannot be empty": "rfCard không được để trống",
        "the IDAccess already exist": "IDAccess đã tồn tại",
        "the resident cannot be empty": "cư dân không được để trống",
        "the fingerprint cannot be empty": "dấu vân tay không được để trống",
        "the face cannot be empty": "khuôn mặt không được để trống",
        "not found pin": "không tìm thấy mã pin",
        "not found rfCard": "không tìm thấy rfCard",
        "not found IDAccess": "không tìm thấy IDAccess",
        "not found fingerprint": "không tìm thấy dấu vân tay",
        "not found face": "không tìm thấy khuôn mặt",
        "face pic is invalid.": "hình ảnh khuôn mặt không hợp lệ.",
        "community build and room cannot be empty.": "xây dựng cộng đồng và phòng không được để trống.",
        "device info mac cannot be empty.": "thông tin thiết bị mac không được để trống.",
        "scheduler type must be 0,1,2 or time format is invalid or dataflag not in 0-127.": "loại bộ định lịch phải là 0, 1, 2 hoặc định dạng thời gian không hợp lệ hoặc dataflag không nằm trong khoảng 0-127.",
        "MAC address cannot be empty.": "Địa chỉ MAC không được để trống.",
        "MAC address 0C1105000000 is not allowed.": "Không cho phép dùng địa chỉ MAC 0C1105000000.",
        "MAC address must be 12 hexadecimal characters.": "Địa chỉ MAC phải gồm 12 ký tự thập lục phân.",
        "Scheduler type value is invalid.": "Giá trị loại bộ định lịch không hợp lệ.",
        "parse is fail": "phân tích thất bại",
        "the fingerprint already exist": "dấu vân tay đã tồn tại",
        "the licensePlate cannot be empty": "biển số xe không được để trống",
        "the licensePlate already exist": "biển số xe đã tồn tại",
        "idaccess run must be 10 digit number or end with -K.": "idaccess run phải là số 10 chữ số hoặc kết thúc bằng -K.",
        "idaccess serial must be 9 digit number.": "idaccess serial phải là số gồm 9 chữ số.",
        "relay not in 0-15": "rơle không nằm trong khoảng 0-15",
        "security relay not in 0-3": "rơle an ninh không nằm trong khoảng 0-3",
        "file name is wrong": "tên tệp sai",
        "access mode specified": "xác định chế độ truy cập",
        "create community user accessmode failed.": "Tạo chế độ truy cập người dùng cộng đồng thất bại.",
        "delete community user accessmode failed.": "Xóa chế độ truy cập người dùng cộng đồng thất bại.",
        "Cannot delete building because it has associated users.": "Không thể xóa tòa nhà vì có người dùng liên kết.",
        "Cannot delete building because it has associated Salto devices.": "Không thể xóa tòa nhà vì nó có thiết bị Salto liên kết.",
        "community building not found": "không tìm thấy tòa nhà cộng đồng",
        "Invalid Name Display": "Tên hiển thị không hợp lệ",
        "The Community does not exist.": "Cộng đồng không tồn tại.",
        "Update CommunityIsInstallerKit Error.": "Lỗi cập nhật CommunityIsInstallerKit.",
        "Dis Not SupportCommunityCalls Error.": "Đại lý không hỗ trợ cuộc gọi cộng đồng.",
        "Community Has Special Device, Not Allowed To Delete.": "Cộng đồng có thiết bị đặc biệt, không được phép xóa.",
        "The project smart home switch must be disabled": "Công tắc nhà thông minh của dự án phải bị vô hiệu hóa",
        "There are ITec Locks in project": "Có khóa ITec trong dự án",
        "There are Salto Locks in project": "Có khóa Salto trong dự án",
        "There are Dormakaba Locks in project": "Có khóa Dormakaba trong dự án",
        "It is rent manager project": "Đây là dự án rent manager",
        "It is installer account": "Đây là tài khoản của nhà lắp đặt",
        "contact preference type": "loại ưu tiên liên lạc",
        "Floor list is required when not all floors.": "Danh sách tầng bắt buộc khi không phải tất cả các tầng.",
        "Building floors list is required when all buildings.": "Danh sách các tầng của tòa nhà là bắt buộc khi tất cả các tòa nhà.",
        "Indoor monitor name is required.": "Tên màn hình trong nhà là bắt buộc.",
        "The primary account is not activated.": "Tài khoản chính chưa được kích hoạt.",
        "You can\'t create more family member accounts.": "Bạn không thể tạo thêm tài khoản thành viên gia đình.",
        "community user not found": "không tìm thấy người dùng cộng đồng",
        "community is empty": "cộng đồng trống",
        "the end user not master user": "người dùng cuối không phải là người dùng chính",
        "the end user not member user": "người dùng cuối không phải là người dùng thành viên",
        "The email already exists and cannot be repeated": "Email đã tồn tại và không thể lặp lại",
        "The mobile Number already exists": "Số điện thoại đã tồn tại",
        "The room number format error.": "Lỗi định dạng số phòng.",
        "community not found": "không tìm thấy cộng đồng",
        "resident not found": "không tìm thấy cư dân",
        "installer not found": "không tìm thấy người cài đặt",
        "Operation Failed!": "Thao tác thất bại!",
        "You don\'t have operate permission": "Bạn không có quyền thao tác",
        "You cannot select Relay and Door at the same time": "Bạn không thể chọn đồng thời rơle và cửa",
        "user don\'t active": "người dùng chưa kích hoạt",
        "User has expired": "Người dùng đã hết hạn",
        "timestamp must be within 3 minutes of current server time": "Dấu thời gian phải trong vòng 3 phút so với thời gian hiện tại của máy chủ",
        "cannot find single rf Card.": "Không thể tìm thấy thẻ rf đơn.",
        "cannot find community rf Card.": "Không thể tìm thấy thẻ rf cộng đồng.",
        "smartLock model": "mẫu khóa thông minh",
        "the project does not open smart home": "dự án này chưa kích hoạt nhà thông minh",
        "php web server error": "lỗi máy chủ web php",
        "Ins not found.": "Không tìm thấy Ins.",
        "RentManage Unit Not Set.": "Đơn vị RentManage chưa được cài đặt.",
        "add audit log error": "lỗi thêm nhật ký kiểm tra",
        "check building in error": "lỗi kiểm tra tòa nhà",
        "Special devices cannot be deleted": "Thiết bị đặc biệt không thể xóa",
        "the email is empty": "email để trống",
        "the email format is incorrect": "định dạng email không đúng",
        "the mobile number is empty": "số điện thoại để trống",
        "the mobile number format is incorrect": "định dạng số điện thoại không đúng",
        "Site not found": "Không tìm thấy dự án",
        "User not found": "không tìm thấy người dùng",
        "invalid time format": "định dạng thời gian không hợp lệ",
        "ground floor type": "định dạng tầng giữa",
        "Start floor range error, valid values are -10 to -1, G0, G1, G2, 1 to 128.": "Lỗi phạm vi tầng bắt đầu, giá trị hợp lệ là -10 đến -1, G0, G1, G2, 1 đến 128.",
        "Building ID must be between 1 and 99.": "ID tòa nhà phải từ 1 đến 99.",
        "Community building name": "Tên tòa nhà cộng đồng",
        "Building ID already exists in this community.": "ID tòa nhà đã tồn tại trong cộng đồng này.",
        "building ID": "ID tòa nhà",
        "Community building not found.": "Không tìm thấy tòa nhà cộng đồng.",
        "Cannot delete building because it has associated devices.": "Không thể xóa tòa nhà vì có thiết bị liên kết.",
        "project is not valid": "dự án không hợp lệ",
        "Cannot delete building because it has associated salto devices.": "Không thể xóa tòa nhà vì có thiết bị salto liên kết.",
        "Cannot delete building because it has associated iTec devices.": "Không thể xóa tòa nhà vì có thiết bị iTec liên kết.",
        "Cannot delete building because it has associated dormakaba devices.": "Không thể xóa tòa nhà vì có thiết bị dormakaba liên kết.",
        "member limit num": "giới hạn số lượng thành viên",
        "Indoor Monitor No Set Error.": "Lỗi chưa cài đặt màn hình trong nhà.",
        "The room not has indoor": "Phòng không có thiết bị trong nhà.",
        "check user in building error": "kiểm tra lỗi người dùng trong tòa nhà",
        "The name specified is already in use.": "Tên đã được sử dụng.",
        "This timeblock overlaps with an existing one. Please adjust it.": "Khoảng thời gian này bị trùng với một khoảng thời gian đã có. Vui lòng điều chỉnh lại.",
        "This door status changed. Please try again.": "Trạng thái cửa đã thay đổi. Vui lòng thử lại.",
        "the lock can\'t bind this community": "Khóa này không thể liên kết cộng đồng này.",
        "The custom quantity limit has been exceeded!": "Đã vượt quá giới hạn số lượng tùy chỉnh!",
        "This time span overlaps with an existing one. Please adjust it.": "Khoảng thời gian này bị trùng với một khoảng thời gian hiện có. Vui lòng điều chỉnh lại.",
        "This one time runs overlap with an existing one time runs effective time. Please adjust it.": "Thời gian thực hiện một lần này bị trùng với thời gian hiệu lực của một lần thực hiện hiện có. Vui lòng điều chỉnh lại.",
        "Operation Failed. Please try again.": "Thao tác thất bại. Vui lòng thử lại.",
        "The image is not a front view.": "Hình ảnh này không phải là góc nhìn từ phía trước.",
        "A mask was detected.": "Đã phát hiện khẩu trang.",
        "The image resolution is too low.": "Độ phân giải của hình ảnh quá thấp.",
        "No face was detected.": "Không phát hiện được khuôn mặt.",
        "The file size is too large.": "Kích thước tệp quá lớn.",
        "The face in the image is too large.": "Khuôn mặt trong hình quá lớn.",
        "The face in the image is too small.": "Khuôn mặt trong hình quá nhỏ.",
        "Multiple faces detected.": "Phát hiện nhiều khuôn mặt.",
        "The face is not clear enough.": "Khuôn mặt không đủ rõ.",
        "Face detection failed.": "Phát hiện khuôn mặt không thành công.",
        "Please enter a value between 1 and 9999": "Vui lòng nhập giá trị từ 1 đến 9999",
        "Please select which input your door sensor is connected to.": "Vui lòng chọn đầu vào mà cảm biến cửa của bạn được kết nối.",
        "Add temp key failed, please try it again": "Thêm khóa tạm thời thất bại, vui lòng thử lại.",
        "Dis Not Support Dynamic QRCode Error.": "Lỗi đại lý không hỗ trợ mã QR động.",
        "QR code not exist": "Mã QR không tồn tại",
        "The temp key has expired.": "Khóa tạm thời đã hết hạn.",
        "The device is not in the office": "Thiết bị không ở trong văn phòng.",
        "The device is already assigned.": "Thiết bị đã được phân bổ.",
        "The device cannot be assigned to any user.": "Thiết bị không thể được gán cho bất kỳ người dùng nào.",
        "You cannot select an option with fewer users than the current project members.": "Bạn không thể chọn một tùy chọn có số lượng người dùng ít hơn số thành viên hiện tại của dự án.",
        "File check failed. Please download the latest template and try again.": "Kiểm tra tệp không thành công. Vui lòng tải mẫu mới nhất và thử lại.",
        "Dynamic QR Code not active.": "Mã QR động chưa hoạt động.",
        "Dynamic QR Code not enable.": "Mã QR động chưa được kích hoạt.",
        "{0} not found.": "Không tìm thấy {0}.",
        "Tier charge plan": "Kế hoạch tính phí theo bậc",
        "Feature billing charge plan new": "Tính năng kế hoạch tính phí mới",
        "Feature billing gradient charge plan": "Kế hoạch tính phí theo bậc thang cho tính năng",
        "The exit time cannot be earlier than the entry time.": "Thời gian ra không thể sớm hơn thời gian vào.",
        "User Name or Password": "Tên người dùng hoặc mật khẩu",
        "You can only link up to 5 sites.": "Bạn chỉ có thể liên kết tối đa 5 dự án.",
        "This license plate is already registered to a resident and cannot be added to the blocklist.": "Biển số này đã được đăng ký cho một cư dân và không thể thêm vào danh sách chặn.",
        "This license plate is blocklisted and cannot be registered as a vehicle.": "Biển số này đã bị đưa vào danh sách đen và không thể đăng ký làm phương tiện.",
        "Elevator not configured in company access floor.": "Thang máy chưa được cấu hình tại các tầng truy cập của công ty.",
        "the device is not in the office": "Thiết bị không ở trong văn phòng.",
        "A maximum of 1000 data items can be imported": "Có thể nhập tối đa 1000 mục dữ liệu.",
        "Exit time cannot be later than the current time.": "Thời gian ra không thể muộn hơn thời gian hiện tại.",
        "You can only import a file at a time in the current parking lot.": "Trong bãi đỗ xe hiện tại, bạn chỉ có thể nhập một tệp mỗi lần.",
        "The license plate is already in the blocklist.": "Biển số xe đã có trong danh sách chặn.",
        "Building name too long.": "Tên tòa nhà quá dài.",
        "Unlock failed. Permission denied by user.": "Mở khóa thất bại. Quyền truy cập bị người dùng từ chối.",
        "Please remove the sensor device(s) before disabling this feature.": "Vui lòng gỡ thiết bị cảm biến trước khi tắt tính năng này.",
        "Operation failed! Daily limit of 15 records exceeded for this user.": "Thao tác thất bại! Người dùng này đã vượt quá giới hạn 15 bản ghi mỗi ngày.",
        "A maximum of {0} public devices can be created within a single project. If you need to add more public devices, please contact Akuvox Technical Support at support@akuvox.com.": "Mỗi dự án có thể thêm tối đa {0} thiết bị công cộng. Để thêm nhiều hơn, vui lòng liên hệ Bộ phận hỗ trợ kỹ thuật Akuvox qua support{'@'}akuvox.com.",
        "A maximum of {0} apartment devices can be created within a single project. If you need to add more apartment devices, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartment devices can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} buildings can be created within a single project. If you need to add more buildings, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} buildings can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} apartments can be created within a single project. If you need to add more apartments, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} apartments can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} residents can be created within a single project. If you need to add more residents, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} residents can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} delivery personnel can be created within a single project. If you need to add more delivery personnel, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} delivery personnel can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} access groups can be created within a single project. If you need to add more access groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} access groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} office groups can be created within a single project. If you need to add more office groups, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} office groups can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} admins can be created within a single project. If you need to add more admins, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} admins can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} companies can be created within a single project. If you need to add more companies, please contact Akuvox Technical Support at support@akuvox.com.": "Up to {0} companies can be added per project. To add more, please contact Akuvox Technical Support at support{'@'}akuvox.com.",
        "A maximum of {0} personnel accounts can be created within a single project. If you need to add more personnel accounts, please contact Akuvox Technical Support at support@akuvox.com.": "Mỗi dự án có thể thêm tối đa {0} tài khoản nhân sự. Để thêm nhiều hơn, vui lòng liên hệ Bộ phận hỗ trợ kỹ thuật Akuvox qua support{'@'}akuvox.com.",
        "None": "Không có",
        "auto": "Tự động",
        "cancel": "Hủy bỏ",


    }
};
